import Grid2 from '@mui/material/Unstable_Grid2';
import { Button } from '@mui/material';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { TextField } from 'src/shared/components/Form/TextField';
import { Step } from '../../components/Step';
import { type ConnectBizneoArgs, credentialInputList } from '../utils';

type Step1Props = {
  triggerConnection: (args: ConnectBizneoArgs) => void;
  isConnectBtnDisabled: boolean;
};

export const Step1 = ({ triggerConnection, isConnectBtnDisabled }: Step1Props) => {
  const { t } = useTranslation('settings');
  const { values } = useFormState();
  const { subsidiary, apiKey, baseUrl } = values ?? {};

  return (
    <Step
      title={`${t('integrations.step')} 1`}
      subtitle={t('integrations.bizneo.enter your bizneo credentials')}
      Icon={VpnKeyIcon}
    >
      <Grid2 xs={12} sx={{ paddingLeft: 0, paddingRight: 0 }}>
        {credentialInputList.map(input => (
          <Grid2 key={input.name} xs={12} sx={{ marginBottom: 1 }}>
            <TextField sx={{ width: '300px' }} label={t(input.label)} name={input.name} />
          </Grid2>
        ))}
        <Grid2 xs={12}>
          <Button
            variant="contained"
            disabled={isConnectBtnDisabled}
            onClick={() => {
              triggerConnection({
                subsidiary,
                body: { apiKey, baseUrl },
                noAutoLogout: true
              });
            }}
          >
            {t('integrations.connect')}
          </Button>
        </Grid2>
      </Grid2>
    </Step>
  );
};
